<template>
  <div class="content-container">
    <div class="audit-container">
      <!-- AUDIT SECTION -->
      <div v-if="hasAuditPermission" class="content-box">
        <div class="section-box outline">
          <div class="das-form-container">
            <search-comp
              @onSearch="onAuditFormSearch"
              @onReset="onAuditFormReset"
            >
              <div class="das-form-container">
                <div class="das-form-group">
                  <div class="das-form-row">
                    <div class="das-form-col col-4 col__date-range">
                      <div class="das-form-input">
                        <div class="label">{{ $t('field.date') }}</div>
                        <CalendarSelect
                          v-model="auditSearchParams.date"
                          :min-max="{
                            max: this.$moment()
                              .endOf('day')
                              .format('YYYY-MM-DD')
                          }"
                          mode="date"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </search-comp>

            <div class="das-form-title-container mb-10">
              <div class="das-form-title">
                <span class="main-title">Danh sách kiểm toán</span>
              </div>
            </div>
            <div v-loading="gridLoading1" class="grid-scroll">
              <GridVx
                ref="cashierAgGrid"
                :columns="accountColumns"
                :rows="accountRows"
                :auto-size-cell="true"
                class="agGrid"
                @selectionChanged="onSelectRowAudit"
              />
            </div>
            <div class="button-containers mb-0">
              <button
                :disabled="disableAuditUpdate"
                class="btn primary small"
                @click="fnOpenDialog"
              >
                Nhập số liệu kiểm toán
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- END AUDIT SECTION -->

      <!-- CASHIER SECTION -->
      <div v-if="hasCashierPermission" class="content-box">
        <div class="section-box outline">
          <search-comp
            @onSearch="onCashierFormSearch"
            @onReset="onCashierFormReset"
          >
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-4 col__date-range">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.date') }}</div>
                      <CalendarSelect
                        v-model="cashierSearchParams.date"
                        :min-max="{
                          max: this.$moment().endOf('day').format('YYYY-MM-DD')
                        }"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </search-comp>
          <div class="das-form-container">
            <div class="das-form-title-container mb-10">
              <div class="das-form-title">
                <span class="main-title">Xác nhận kiểm toán</span>
              </div>
            </div>
            <div v-loading="gridLoading2" class="grid-scroll">
              <GridVx
                ref="auditAgGrid"
                :columns="cashierColumns"
                :rows="cashierRows"
                :context="context"
                :auto-size-cell="true"
                class="agGrid"
                @selectionChanged="onSelectedRowCashier"
              />
            </div>
            <!-- <div class="button-containers mb-0">
              <button :disabled="disableAuditUpdate" class="btn primary small">
                Báo cáo kiểm toán sai lệch
              </button>
              <button :disabled="disableAuditUpdate" class="btn primary small">
                Xác nhận kiểm toán
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- END CASHIER SECTION -->
    </div>

    <!-- DIALOG -->
    <!-- AUDIT DIALOG -->
    <el-dialog
      title="Nhập số liệu kiểm toán"
      :visible.sync="dialogAuditFormVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <div class="das-form-container">
        <section class="mb-20">
          <!-- <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title p-0">Thông tin kiểm toán</span>
            </div>
          </div> -->
          <div class="das-info-title mt-0">Thông tin kiểm toán</div>

          <InfoList :columns="1" class="profile__info-list">
            <InfoListLabel style="">Thu ngân</InfoListLabel>
            <InfoListValue style="min-width: 250px">{{
              selectedRowAudit?.cashier_username
            }}</InfoListValue>
            <InfoListLabel style="">Ngày</InfoListLabel>
            <InfoListValue style="min-width: 250px">{{
              $displayDate(selectedRowAudit?.date)
            }}</InfoListValue>
          </InfoList>
        </section>
        <validation-observer ref="formValidator">
          <!-- <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title p-0">Số liệu kiểm toán</span>
            </div>
          </div> -->
          <div class="das-info-title">Số liệu kiểm toán</div>

          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Chuyển khoản</div>
                  <validation-provider
                    rules="required|min_value:0|number"
                    name="Chuyển khoản"
                  >
                    <VxCurrencyInput v-model="auditForm.bank_accountant" />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tiền mặt</div>
                  <validation-provider
                    rules="required|min_value:0|number"
                    name="Tiền mặt"
                  >
                    <VxCurrencyInput v-model="auditForm.cash_accountant" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Thẻ</div>
                  <validation-provider
                    rules="required|min_value:0|number"
                    name="Thẻ"
                  >
                    <VxCurrencyInput v-model="auditForm.card_accountant" />
                  </validation-provider>
                </div>
              </div>
              <!-- <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Công nợ</div>
                  <validation-provider
                    rules="required|min_value:0|number"
                    name="Công nợ"
                  >
                    <VxCurrencyInput v-model="auditForm.debt_accountant" />
                  </validation-provider>
                </div>
              </div> -->
            </div>
          </div>
        </validation-observer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogAuditFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="fnUpdateAudit">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <CashierConfirmDialog
      v-if="dialogCashierConfirmVisible"
      :revenue-data="selectedRowCashier"
      :type="dialogCashierConfirmType"
      @resetData="onResetDataCashier"
      @close="dialogCashierConfirmVisible = false"
    />
  </div>
</template>

<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CashierActionsCell from './components/CashierActionsCell.vue'
import AuditStatusCell from './components/AuditStatusCell.vue'
import CashierConfirmDialog from './components/CashierConfirmDialog.vue'
import { DEFAULT_GRID_COL_DEF } from '@/constant'
// eslint-disable-next-line no-unused-vars
import { CONFIRM_STATUS, CASHIER_CONFIRM_TYPE } from './constant'

import {
  getAccountRevenueApi,
  // eslint-disable-next-line no-unused-vars
  updateAccountRevenueApi,
  // eslint-disable-next-line no-unused-vars
  getCashierRevenueApi,
  // eslint-disable-next-line no-unused-vars
  updateAccountRevenueByCashier
} from '@/api/cashier_service/audit'

// eslint-disable-next-line no-unused-vars
import { getUserDetailApi } from '@/api/profile/profile'

const valueFormatterTooltipCell = {
  valueFormatter: params => {
    if (params.value !== null && params.value !== undefined) {
      return Number(params.value).toLocaleString('en')
    } else {
      return null
    }
  },
  tooltipValueGetter: params => {
    if (params.value !== null && params.value !== undefined) {
      return Number(params.value).toLocaleString('en')
    } else {
      return null
    }
  }
}

const getDefaultAuditForm = () => ({
  bank_accountant: null,
  cash_accountant: null,
  card_accountant: null,
  cashier_id: null,
  id: null,
  accountant_id: null
})

const AUDIT_GROUP_NAME = 'Acc-All'

const CASHIER_GROUP_NAME = 'Cashier'
const FO_GROUP_NAME = 'FO-All'

export default {
  components: {
    CalendarSelect,
    // eslint-disable-next-line vue/no-unused-components
    CashierActionsCell,
    // eslint-disable-next-line vue/no-unused-components
    AuditStatusCell,
    CashierConfirmDialog
  },
  data() {
    return {
      auditSearchParams: {
        date: this.$moment().format('YYYY-MM-DD')
      },
      cashierSearchParams: {
        date: this.$moment().format('YYYY-MM-DD')
      },

      dateRange: {
        start: null,
        end: null
      },

      auditForm: getDefaultAuditForm(),

      // GRID
      accountColumns: [
        // {
        //   headerName: 'Ngày',
        //   field: 'create_date',
        //   headerClass: 'header-row-span-2',
        //   tooltipValueGetter: params => {
        //     return params.value ? dateFormatter(params.value) : null
        //   },
        //   valueFormatter: params => {
        //     return params.value ? dateFormatter(params.value) : null
        //   },
        //   minWidth: 120,
        //   maxWidth: 120,
        //   sortable: false
        // },
        {
          headerName: 'Thu ngân',
          field: 'cashier_username',
          tooltipField: 'cashier_username',
          headerClass: 'header-row-span-2',
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bank_sys',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            },
            {
              headerName: 'Tiền mặt',
              field: 'cash_sys',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            },
            {
              headerName: 'Thẻ',
              field: 'card_sys',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              headerClass: 'last-header-cell-group',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            }
            // {
            //   headerName: 'Công nợ',
            //   field: 'debt_system',
            //   ...valueFormatterTooltipCell,
            //   cellClass: 'ag-cell-right',
            //   minWidth: 150,
            //   maxWidth: 150,
            //   sortable: false
            // },
            // {
            //   headerName: 'Miễn phí',
            //   field: 'foc_system',
            //   ...valueFormatterTooltipCell,
            //   headerClass: 'last-header-cell-group',
            //   cellClass: 'ag-cell-right',
            //   minWidth: 150,
            //   maxWidth: 150,
            //   sortable: false
            // }
          ]
        },
        {
          headerName: 'Tổng tiền kế toán thu',
          field: 'total_accountant',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          minWidth: 180,
          sortable: false,
          ...valueFormatterTooltipCell
          // valueFormatter: params => {
          //   const value =
          //     Number(params.data.bank_accountant) +
          //     Number(params.data.card_accountant) +
          //     Number(params.data.cash_accountant)
          //   return value.toLocaleString('en')
          // },
          // tooltipValueGetter: params => {
          //   const value =
          //     Number(params.data.bank_accountant) +
          //     Number(params.data.card_accountant) +
          //     Number(params.data.cash_accountant)
          //   return value.toLocaleString('en')
          // }
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bank_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            },
            {
              headerName: 'Tiền mặt',
              field: 'cash_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            },
            {
              headerName: 'Thẻ',
              field: 'card_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              headerClass: 'last-header-cell-group',
              minWidth: 150,
              maxWidth: 150,
              sortable: false
            }
            // {
            //   headerName: 'Công nợ',
            //   field: 'debt_accountant',
            //   ...valueFormatterTooltipCell,
            //   headerClass: 'last-header-cell-group',
            //   cellClass: 'ag-cell-right',
            //   minWidth: 150,
            //   maxWidth: 150,
            //   sortable: false
            // }
          ]
        },
        // {
        //   headerName: 'Tổng tiền chênh lệch',
        //   field: 'total_difference',
        //   ...valueFormatterTooltipCell,
        //   headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
        //   cellClass: 'ag-cell-right',
        //   minWidth: 180,
        //   maxWidth: 180,
        //   sortable: false
        // },
        // {
        //   headerName: 'Các phương thức thanh toán',
        //   children: [
        //     {
        //       headerName: 'Chuyển khoản',
        //       field: 'banking_difference',
        //       ...valueFormatterTooltipCell,
        //       cellClass: 'ag-cell-right',
        //       minWidth: 150,
        //       maxWidth: 150,
        //       sortable: false
        //     },
        //     {
        //       headerName: 'Tiền mặt',
        //       field: 'cash_difference',
        //       ...valueFormatterTooltipCell,
        //       cellClass: 'ag-cell-right',
        //       minWidth: 150,
        //       maxWidth: 150,
        //       sortable: false
        //     },
        //     {
        //       headerName: 'Thẻ',
        //       field: 'card_difference',
        //       ...valueFormatterTooltipCell,
        //       cellClass: 'ag-cell-right',
        //       minWidth: 150,
        //       maxWidth: 150,
        //       sortable: false
        //     },
        //     {
        //       headerName: 'Công nợ',
        //       field: 'debt_difference',
        //       ...valueFormatterTooltipCell,
        //       headerClass: 'last-header-cell-group',
        //       cellClass: 'ag-cell-right',
        //       minWidth: 150,
        //       maxWidth: 150,
        //       sortable: false
        //     }
        //   ]
        // },
        {
          headerName: 'Kiểm toán',
          field: 'accountant_username',
          tooltipField: 'accountant_username',
          minWidth: 150,
          headerClass: ['header-row-span-2', 'header-cell-suffix-group']
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          minWidth: 160,
          maxWidth: 160,
          pinned: 'right',
          lockPinned: true,
          cellRenderer: 'AuditStatusCell',
          sortable: false
        }
      ],
      accountRows: [
        // {
        //   confirm_status: CONFIRM_STATUS.NOT_AUDIT
        // },
        // {
        //   confirm_status: CONFIRM_STATUS.AUDITED
        // },
        // {
        //   confirm_status: CONFIRM_STATUS.CONFIRMED
        // },
        // {
        //   confirm_status: CONFIRM_STATUS.RESPONSE_WRONG
        // }
      ],

      cashierColumns: [
        {
          headerName: 'Thu ngân',
          field: 'cashier_username',
          tooltipField: 'cashier_username',
          headerClass: 'header-row-span-2',
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Tổng tiền kế toán thu',
          field: 'total_money_in_accountant',
          ...valueFormatterTooltipCell,
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          minWidth: 180,
          sortable: false
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bank_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 200,
              sortable: false
            },
            {
              headerName: 'Tiền mặt',
              field: 'cash_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              minWidth: 150,
              maxWidth: 200,
              sortable: false
            },
            {
              headerName: 'Thẻ',
              field: 'card_accountant',
              ...valueFormatterTooltipCell,
              cellClass: 'ag-cell-right',
              headerClass: 'last-header-cell-group',
              minWidth: 150,
              maxWidth: 200,
              sortable: false
            }
            // {
            //   headerName: 'Công nợ',
            //   field: 'debt_accountant',
            //   ...valueFormatterTooltipCell,
            //   headerClass: 'last-header-cell-group',
            //   cellClass: 'ag-cell-right',
            //   minWidth: 150,
            //   // maxWidth: 200,
            //   sortable: false
            // }
          ]
        },
        {
          headerName: 'Kế toán',
          field: 'accountant_username',
          tooltipField: 'accountant_username',
          minWidth: 150,
          headerClass: ['header-row-span-2', 'header-cell-suffix-group']
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          minWidth: 150,
          maxWidth: 150,
          pinned: 'right',
          lockPinned: true,
          cellRenderer: params => {
            switch (params.value) {
              case CONFIRM_STATUS.AUDITED:
                return 'Đã kiểm toán'
              case CONFIRM_STATUS.CONFIRMED:
                return 'Đã xác nhận'
              case CONFIRM_STATUS.RESPONSE_WRONG:
                return 'Phản hồi sai'
            }

            return ''
          },
          tooltipValueGetter: params => {
            switch (params.value) {
              case CONFIRM_STATUS.AUDITED:
                return 'Đã kiểm toán'
              case CONFIRM_STATUS.CONFIRMED:
                return 'Đã xác nhận'
              case CONFIRM_STATUS.RESPONSE_WRONG:
                return 'Phản hồi sai'
            }

            return ''
          },
          sortable: false
        },
        {
          headerName: 'Xác nhận',
          field: 'action',
          minWidth: 120,
          maxWidth: 120,
          pinned: 'right',
          lockPinned: true,
          cellRenderer: 'CashierActionsCell',
          sortable: false
        },
        {
          headerName: '',
          field: 'date',
          minWidth: 0,
          maxWidth: 0,
          hide: true
        }
      ],
      cashierRows: [
        // {
        //   confirm_status: CONFIRM_STATUS.AUDITED
        // },
        // {
        //   confirm_status: CONFIRM_STATUS.CONFIRMED
        // },
        // {
        //   confirm_status: CONFIRM_STATUS.RESPONSE_WRONG
        // }
      ],
      defaultColDef: {
        ...DEFAULT_GRID_COL_DEF
        // wrapHeaderText: true,
        // autoHeaderHeight: true
        // headerComponentParams: params => {
        //   console.log(params)
        //   return {
        //     template:
        //       '<div class="ag-cell-label-container" role="presentation">' +
        //       '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
        //       '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
        //       '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
        //       '  </div>' +
        //       '</div>'
        //   }
        // }
      },
      selectedRowAudit: null,
      selectedRowCashier: null,
      context: null,
      gridLoading1: false,
      gridLoading2: false,

      // DIALOG
      dialogAuditFormVisible: false,
      dialogCashierConfirmVisible: false,
      dialogCashierConfirmType: null,

      // USER ROLE
      userGroups: []
    }
  },

  computed: {
    disableAuditUpdate() {
      return (
        !this.selectedRowAudit ||
        !this.checkDateIsToday(this.selectedRowAudit.date) ||
        this.selectedRowAudit.status === CONFIRM_STATUS.CONFIRMED
      )
    },
    hasAuditPermission() {
      return this.userGroups.includes(AUDIT_GROUP_NAME)
    },
    hasCashierPermission() {
      return (
        this.userGroups.includes(CASHIER_GROUP_NAME) ||
        this.userGroups.includes(FO_GROUP_NAME)
      )
    }
  },
  watch: {
    dialogAuditFormVisible: {
      handler(val) {
        if (!val) {
          this.auditForm = getDefaultAuditForm()
        }
      }
    }
  },
  async beforeMount() {
    this.context = { componentParent: this }

    await this.getUserInfo()
  },
  async mounted() {
    this.attachAuditData()
    this.attachCashierData()
  },
  methods: {
    handleNoPermission() {
      if (!this.hasAuditPermission && !this.hasCashierPermission) {
        this.$message({
          message: this.$t('errorMsg.authorization'),
          type: 'error',
          duration: 4 * 1000
        })
        this.$router.push('/')
      }
    },
    checkDateIsToday(date) {
      return this.$moment(date).isSame(this.$moment(), 'day')
    },

    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 20
      var height = this.headerHeightGetter() + padding
      this.$refs.cashierAgGrid.gridApi.setHeaderHeight(height)
      this.$refs.cashierAgGrid.gridApi.resetRowHeights()
    },

    onAuditFormSearch() {
      // this.auditSearchParams = Object.assign(this.auditSearchParams, {
      //   dateFrom: this.dateRange.start,
      //   dateTo: this.dateRange.end
      // })
      this.attachAuditData()
    },

    onAuditFormReset() {
      this.auditSearchParams = {
        date: this.$moment().format('YYYY-MM-DD')
      }
      // this.dateRange = {
      //   start: null,
      //   end: null
      // }

      this.attachAuditData()
    },

    onCashierFormSearch() {
      this.attachCashierData()
    },

    onCashierFormReset() {
      this.cashierSearchParams = {
        date: this.$moment().format('YYYY-MM-DD')
      }
      this.attachCashierData()
    },

    onSelectRowAudit(selectedRows) {
      this.selectedRowAudit = selectedRows?.[0]
    },

    onSelectedRowCashier(selectedRows) {
      this.selectedRowCashier = selectedRows?.[0]
    },

    attachAuditData() {
      this.selectedRowAudit = null
      this.gridLoading1 = true
      getAccountRevenueApi(this.auditSearchParams)
        .then(res => {
          this.accountRows = res.data.map(item => {
            const total_sys =
              Number(item.bank_sys) +
              Number(item.card_sys) +
              Number(item.cash_sys)
            const total_accountant =
              Number(item.bank_accountant) +
              Number(item.card_accountant) +
              Number(item.cash_accountant)
            // const total_diff = total_sys - total_accountant

            return {
              ...item,
              total_sys,
              total_accountant
              // total_diff
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading1 = false
        })
    },

    attachCashierData() {
      this.gridLoading2 = true
      getCashierRevenueApi(this.cashierSearchParams)
        .then(res => {
          this.cashierRows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading2 = false
        })
    },

    async getUserInfo() {
      await getUserDetailApi().then(res => {
        this.userGroups = res.data.user.user_group_ids.map(item => item.name)

        const hasPermission = this.userGroups.find(
          item =>
            item === CASHIER_GROUP_NAME ||
            item === AUDIT_GROUP_NAME ||
            item === FO_GROUP_NAME
        )

        if (!hasPermission) {
          this.$message({
            message: this.$t('errorMsg.authorization'),
            type: 'error',
            duration: 4 * 1000
          })
          this.$router.push('/')
        }
      })
    },

    async fnUpdateAudit() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = {
        ...this.auditForm,
        cashier_id: this.selectedRowAudit.cashier_id,
        id: this.selectedRowAudit.id ?? null,
        accountant_id: this.selectedRowAudit.accountant_id,
        status: this.selectedRowAudit.status
      }

      updateAccountRevenueApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachAuditData()

          // Has both roles
          // eslint-disable-next-line no-constant-condition
          if (true) {
            this.attachCashierData()
          }

          this.dialogAuditFormVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    fnOpenDialog() {
      this.dialogAuditFormVisible = true
      this.auditForm = {
        id: this.selectedRowAudit.id,
        bank_accountant: this.selectedRowAudit.bank_accountant,
        card_accountant: this.selectedRowAudit.card_accountant,
        cash_accountant: this.selectedRowAudit.cash_accountant,
        debt_accountant: this.selectedRowAudit.debt_accountant
      }
    },

    onResetDataCashier() {
      this.attachCashierData()

      // eslint-disable-next-line no-constant-condition
      if (true) {
        this.attachAuditData()
      }
    },

    // ACTIONS

    /**
     * @param type
     * Enum Values:
     * - CASHIER_CONFIRM_TYPE.CONFIRM
     * - CASHIER_CONFIRM_TYPE.REPORT_WRONG
     */
    onCashierAction(type) {
      this.dialogCashierConfirmVisible = true
      this.dialogCashierConfirmType = type
    }
  }
}
</script>

<style></style>

<style scoped lang="scss">
@media only screen and (max-width: 1366px) {
  .col-4.col__date-range {
    --item-col-count: 6 !important;
  }
}

.audit-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  // min-height: 100%;

  .content-box {
    flex: 1;
    min-height: 500px;
  }
}
</style>
